//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { noticeCategoryApi, noticeDetailApi, noticeListApi, allArticlesApi } from '@/api/administration';
import settings from '@/settings';
export default {
  name: 'IndexVue',
  components: {
    noticeDetail: function noticeDetail() {
      return import('./components/noticeDetail');
    },
    defaultPage: function defaultPage() {
      return import('@/components/common/defaultPage');
    }
  },
  data: function data() {
    return {
      where: {
        page: 1,
        limit: 15,
        cate_id: '',
        name: '',
        status: 1
      },
      noticeNav: [],
      total: 0,
      tableData: [],
      defaultImage: require('@/assets/images/notice.png'),
      navIndex: true,
      nweNoticeData: [],
      isDetail: false,
      detailData: {},
      activeName: '0'
    };
  },
  computed: {
    nweNoticelist: function nweNoticelist() {
      if (this.nweNoticeData.length > 5) {
        return this.nweNoticeData.splice(0, 5);
      } else {
        return this.nweNoticeData;
      }
    }
  },
  mounted: function mounted() {
    this.getTargetCate();
    var limit = Math.floor((window.innerHeight - 240) / 155);
    this.where.limit = limit > 0 ? limit : this.where.limit;
    this.getAllArticles();
    this.getNewTableData();
    if (this.$route.query.id) {
      this.itemDetail(this.$route.query.id);
    }
  },
  methods: {
    handleSizeChange: function handleSizeChange(val) {
      this.where.limit = val;
      this.getTableData();
    },
    handleClick: function handleClick(e) {
      var index = Number(e.name);
      var data = this.noticeNav[index];
      this.where.cate_id = data.id;
      this.where.page = 1;
      if (index == 0) {
        this.getAllArticles();
      } else {
        this.getTableData();
      }
    },
    pageChange: function pageChange(page) {
      this.where.page = page;
      this.getTableData();
    },
    // 获取全部文章
    getAllArticles: function getAllArticles() {
      var _this = this;
      this.where.cate_id = '';
      allArticlesApi(this.where).then(function (res) {
        _this.tableData = res.data.list;
        _this.total = res.data.count;
      });
    },
    // 获取表格数据
    getTableData: function getTableData() {
      var _this2 = this;
      noticeListApi(this.where).then(function (res) {
        _this2.tableData = res.data.list || [];
        _this2.total = res.data.count;
      });
    },
    getNewTableData: function getNewTableData() {
      var _this3 = this;
      var data = {
        is_new: 1,
        status: 1
      };
      noticeListApi(data).then(function (res) {
        _this3.nweNoticeData = res.data.list || [];
      });
    },
    getTargetCate: function getTargetCate() {
      var _this4 = this;
      noticeCategoryApi({
        is_show: 1
      }).then(function (res) {
        _this4.noticeNav = res.data ? res.data : [];
        _this4.noticeNav.unshift({
          cate_name: '全部',
          id: 0
        });
      });
    },
    // 获取详情页
    itemDetail: function itemDetail(id) {
      var _this5 = this;
      noticeDetailApi(id).then(function (res) {
        _this5.detailData = res.data;
        _this5.isDetail = true;
        _this5.getNewTableData();
      });
    },
    handleSearch: function handleSearch() {
      this.where.page = 1;
      this.getTableData();
    },
    handleNoticeDetail: function handleNoticeDetail() {
      this.isDetail = false;
      if (this.$route.query.id) {
        this.$router.push({
          path: settings.roterPre + '/user/notice/index',
          query: {}
        });
      }
      if (this.where.cate_id == 0) {
        this.getAllArticles();
      } else {
        this.getTableData();
      }
    }
  }
};